import React from "react";
import { Fade } from "react-awesome-reveal";
import Whats from "./Whats";
import "../styles/Services.scss";
import img1 from "../images/services/1.png";
import img2 from "../images/services/2.png";
import img3 from "../images/services/3.png";
import img4 from "../images/services/4.png";
import img5 from "../images/services/5.png";
import img6 from "../images/services/6.png";

const Services = () => {
  const servicios = [
    {
      id: 1,
      imagen: img1,
      titulo: "Creación de Video Especializado para la Promoción de Productos o Servicios",
      texto:
        'Creamos videos impactantes y persuasivos diseñados para resaltar las características y beneficios clave de tus productos o servicios. Utilizamos tecnología de IA avanzada para generar contenido visualmente atractivo que captura la atención de tu audiencia y mantiene su interés. Estos videos están diseñados estratégicamente para convertir prospectos en clientes, ayudando a aumentar tus ventas y mejorar la conversión. Desde $1,332 por video, obtienes un material profesional y de alta calidad que hará que tu negocio se destaque y se posicione frente a tu competencia.',
    },
    {
      id: 2,
      imagen: img2,
      titulo: "Campañas de Tráfico y Reclutamiento en Redes Sociales",
      texto:
        "Gestionamos y ejecutamos tus campañas publicitarias en redes sociales de forma semanal, diseñadas específicamente para captar la atención de tus clientes potenciales y generar ventas. Optimización constante, segmentación precisa y análisis de rendimiento nos permiten crear campañas efectivas que aumentan el tráfico hacia tus plataformas digitales. Además, nos encargamos de todo el proceso, asegurando que tu mensaje llegue a las personas adecuadas en el momento adecuado.Desde $777 por semana, te ofrecemos un servicio integral que ya incluye la pauta publicitaria.",
    },
    {
      id: 3,
      imagen: img3,
      titulo: "Creación de Imagen Comercial",
      texto:
        "Diseñamos una imagen comercial profesional para ti y tus colaboradores, alineada con los valores y la misión de tu empresa. Nos enfocamos en crear fotos de alta calidad que mejoren la presentación de tu equipo, asegurando que reflejen la identidad y profesionalismo de tu marca. Este servicio es ideal para darle una imagen coherente y atractiva a tu equipo, mejorando la percepción de tu empresa ante clientes y socios. Desde $77 por colaborador, obtienes fotos de alta calidad que elevarán la imagen de tu negocio y fortalecerán tu presencia corporativa.",
    },
    {
      id: 4,
      imagen: img4,
      titulo: "Creación de Landing Page",
      texto:
        "Creamos una Landing Page para tu empresa, diseñada para convertir visitantes en clientes. Nuestro servicio incluye el desarrollo con código limpio y optimizado para un rendimiento SEO excepcional, asegurando que tu página esté bien posicionada en los motores de búsqueda. El diseño se basa en los colores y la imagen de tu marca, y es completamente responsive, adaptándose a cualquier dispositivo. Incluye secciones clave como quiénes somos, tus diferenciadores, una presentación general de tus servicios y botones de redirección a tus redes sociales y WhatsApp para facilitar la interacción con tus clientes. Además, ofrecemos la opción de hacer proyectos escalables para adaptarse al crecimiento de tu negocio, todo esto desde $2,500.",
    },
    {
      id: 5,
      imagen: img5,
      titulo: "Creación de Contenido para Redes Sociales",
      texto:
        "Desde $1,111 mensuales, te ayudamos a mantener tu página activa y vigente con 1 publicación diaria durante todo el mes. Nuestro objetivo es nutrir tu perfil con contenido relevante e informativo sobre tus servicios, para que tus visitantes encuentren lo que buscan y generen confianza en tu marca. Al ofrecer contenido constante y de calidad, aumentamos la credibilidad de tu empresa, lo que facilita cerrar ventas y atraer más clientes. Con nuestra gestión, tu negocio se mantiene presente y competitivo en el mundo digital.",
    },
    {
      id: 6,
      imagen: img6,
      titulo: "Desarrollo de Agentes IA y Chatbots",
      texto:
        "Desarrollamos Agentes IA y chatbots inteligentes para automatizar procesos, optimizar la eficiencia y mejorar la atención al cliente. Nuestros Agentes IA se adaptan a las necesidades de tu negocio, gestionando tareas repetitivas y agilizando operaciones. Los chatbots permiten una comunicación rápida y efectiva en WhatsApp, Facebook y sitios web, brindando soporte 24/7 y mejorando la experiencia del usuario. Con nuestras soluciones, reduces costos, ahorras tiempo y escalas tu negocio con tecnología de vanguardia, impulsando su crecimiento y competitividad.",
    },
  ];

  return (
    <div id="allServices">
      <h4 className="fw-bold title fs-3">Nuestros Servicios</h4>
      {servicios.map((servicio) => (
        <section
          className="cursosContainer"
          id={"servicio" + servicio.id}
          key={servicio.id}
        >
          <div className="imgContainer text-center">
            <Fade duration="1000">
              <img src={servicio.imagen} alt={servicio.titulo} />
            </Fade>
          </div>
          <div className="infoCursoContainer">
            <Fade duration="1000">
              <span className="titleService">
                <strong>{servicio.titulo}</strong>
              </span>
            </Fade>
            <span className="textService">{servicio.texto}</span>

            <div className="btnServiceContainer">
              <Whats
                classStyle="btn btnService"
                phoneNumber="5215531827432"
                message={`¡Me pudiera brindar más información acerca de ${servicio.titulo}!`}
                text="¡Más información!"
              />
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Services;
